import { ManagerRole } from '../../../../../../hooks/auth/usePermissions';

export default {
  form: {
    title: 'Adicionar gestor',
    first_name: {
      label: 'Nome',
      placeholder: 'Walter',
    },
    last_name: {
      label: 'Apelido',
      placeholder: 'White',
    },
    city: {
      label: 'Cidade',
      placeholder: 'Bonn',
    },
    email: {
      label: 'Email',
      placeholder: 'thedanger@foodamigos.io',
    },
    roles: {
      label: 'Função',
      placeholder: 'Selecionar função',
      // Add-form label for store_admin sent with as_owner; other store admins keep "Admin".
      owner_option: 'Proprietário',
      options: {
        [ManagerRole.Admin]: 'Admin',
        [ManagerRole.Reseller]: 'Revendedor',
        [ManagerRole.SalesManager]: 'Gestor de vendas',
        [ManagerRole.SalesLeadership]: 'Líder de vendas',
        [ManagerRole.ContentManager]: 'Gestor de conteúdo',
        [ManagerRole.OnboardingManager]: 'Gestor de onboarding',
        [ManagerRole.MobileAppsManager]: 'Gestor de apps móveis',
        [ManagerRole.StoreAdmin]: 'Admin',
        [ManagerRole.StoreEmployee]: 'Funcionário',
        [ManagerRole.StoreOperator]: 'Operador',
        [ManagerRole.SDR]: 'SDR',
      },
      description: {
        [ManagerRole.StoreOperator]:
          '<strong>Operador:</strong> Acesso total a Vendas, Menu, Itens Mais Vendidos, Horário de Funcionamento, Cartões Oferta, Reservas e Relatórios das empresas atribuídas.',
        [ManagerRole.StoreEmployee]:
          '<strong>Funcionário:</strong> Acesso limitado apenas a Reservas e Cartões Oferta.',
        [ManagerRole.StoreAdmin]:
          '<strong>Proprietário:</strong> Acesso total a um restaurante, incluindo loja online, definições fiscais, marketing e gestão de equipa. Recebe um e-mail com os seus dados de acesso. Apenas um proprietário por restaurante, e outros membros da equipa não podem editá-lo ou removê-lo.',
      },
    },
    companies: {
      label: 'Empresas',
      placeholder: 'Selecionar empresas',
      owner_placeholder: 'Selecionar restaurante',
      has_owner: 'Já tem um proprietário',
    },
  },
  fields: {
    email: 'Email',
    name: 'Nome',
    roles: 'Função',
    created_at: 'Criado',
    actions: 'Ações',
    companies: 'Empresas',
    status: 'Estado',
  },
  tags: {
    owner: 'Proprietário',
    operator: 'Operador',
    employee: 'Funcionário',
  },
  no_owner: {
    title: '{{restaurant}} não tem proprietário',
    description: 'Tudo o que precisa do proprietário fica a aguardar até ser escolhido um.',
  },
  search: {
    placeholder: 'Pesquisar por nome ou email',
  },
  buttons: {
    add_manager: 'Adicionar gestor',
    actions: 'Ações',
    view_dashboard: 'Ver dashboard como este gestor',
    login_as_manager: 'Entrar como este gestor',
    delete: 'Eliminar este gestor',
    resend_owner_invite: 'Reenviar o convite ao proprietário',
    change_owner: 'Remover {{name}} como proprietário',
    delete_named: 'Eliminar {{name}}',
    choose_owner: 'Escolher um proprietário',
  },
  modals: {
    delete_manager: {
      title: 'Tem a certeza que deseja eliminar o gestor {{email}}?',
    },
    update_manager: {
      title: 'Tem a certeza que deseja atualizar o gestor {{email}}?',
    },
    resend_owner_invite: {
      title: 'Reenviar o convite para {{email}}?',
      description: 'O proprietário recebe uma nova palavra-passe por email. A palavra-passe atual deixa de funcionar.',
    },
  },
  toasts: {
    successfully_created_manager: 'Gestor criado com sucesso',
    owner_invited: '{{email}} foi convidado como proprietário do restaurante e receberá os dados de acesso por email.',
    failed_to_load_data: 'Falha ao carregar dados, por favor atualize a página',
    failed_to_create_manager: 'Falha ao criar gestor',
    failed_to_create_magic_link: 'Falha ao criar magic link',
    failed_to_delete_manager: 'Falha ao eliminar gestor',
    manager_got_deleted: 'Gestor eliminado',
    successfully_updated_manager: 'Gestor atualizado',
    failed_to_update_manager: 'Falha ao atualizar gestor',
    owner_invite_resent: 'O convite foi enviado novamente para {{email}}, com uma nova palavra-passe.',
    owner_invite_resend_cooling_down:
      'O convite acabou de ser reenviado. Aguarde alguns minutos antes de o enviar novamente.',
    failed_to_resend_owner_invite: 'Falha ao reenviar o convite',
    owner_changed: '{{name}} é agora o proprietário',
    owner_changed_new: '{{name}} é agora o proprietário. Dados de acesso enviados para {{email}}',
    owner_removed: '{{name}} deixou de ser o proprietário',
  },
};
